import React, { useEffect, useRef, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import $ from "jquery";
import "jquery-ui/dist/jquery-ui.js";
import "jquery-ui/themes/base/all.css";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import * as XLSX from "xlsx";
import { RiFileExcel2Fill } from "react-icons/ri";
function BoardPending() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]); // Store API data
    const tableRef = useRef(null);
    const remarksRef = useRef(null);
    const [modalData, setModalData] = useState({});
    const [chFile, setChFile] = useState();
    const [isImage, setIsImage] = useState(false);
    const [isPDF, setIsPDF] = useState(false);
    const [centerName, setCenterName] = useState();
    const [centerCode, setCenterCode] = useState();
    const modalRef = useRef(null);
    const modalRef2 = useRef(null);
    const token2 = localStorage.getItem("token2");
    const [challanNo, setChallanNo] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalData2, setModalData2] = useState([]);
    const tableRef2 = useRef(null);
    useEffect(() => {
        if (!localStorage.getItem("token2")) {
            navigate("/");
        }
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(`${config.API_BASE_URL}/auth/BoardVerificationPending`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token2}`,
                    },
                });

                if (response.status !== 200) {
                    Swal.fire({
                        icon: "warning",
                        title: "No pending approvals found",
                    });
                    setLoading(false);
                    setData([]); // Ensure no previous data is displayed
                    return;
                }

                const result = await response.json();
                // console.log(result);
                const studentData = result?.data?.board_verification_pending ?? [];
                // console.log(studentData);

                if (studentData.length === 0) {
                    Swal.fire({
                        icon: "warning",
                        title: "Data Not Found",
                    });
                }

                setData(studentData);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                Swal.fire("Error", "Something went wrong!", "error");
                setLoading(false);
                setData([]); // Reset data on failure
            }
        };

        fetchData();
    }, [token2]);

    useEffect(() => {
        if (data.length > 0) {
            const table = $(tableRef.current).DataTable({
                paging: false,
                info: false,
                destroy: true,
                columnDefs: [{ orderable: false, targets: 0 }],
            });

            return () => {
                table.destroy();
            };
        }
    }, [data]);

    useEffect(() => {
        if (modalData2.length > 0) {
            const table = $(tableRef2.current).DataTable();

            if ($.fn.DataTable.isDataTable(tableRef2.current)) {
                table.destroy();
            }

            $(tableRef2.current).DataTable({
                paging: false,
                info: false,
            });
        }
    }, [modalData2]);

    const movetodashboard = (e) => {
        e.preventDefault();
        navigate("/Board-dashboard");
    };
    const openModal = async (challanNo) => {
        try {
            setChallanNo(challanNo);
            setLoading(true);
            // Call the API using POST (since GET doesn't support a body)
            const response = await axios.post(`${config.API_BASE_URL}/auth/ShowPaymentDetails`,
                { challaN_NO: challanNo },
                {
                    headers: {
                        Authorization: `Bearer ${token2}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            // Store the API response data
            setModalData(response.data.data.payment_details[0] || {});
            setChFile(response.data.data.CH_FILE || {})
            setIsImage(/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(response.data.data.CH_FILE));
            setIsPDF(/\.pdf$/i.test(response.data.data.CH_FILE));
            // console.log(response.data.data.payment_details[0]);
            // console.log(response.data.data.CH_FILE);
            // Open the modal using the existing logic
            $('#uploadModal').addClass('show').css('display', 'block');
            $('body').addClass('modal-open').append('<div class="modal-backdrop modal1 fade show"></div>');
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        finally {
            // Hide loader once the modal is opened or if an error occurs
            setLoading(false);
        }
    };
    const openModal2 = () => {
        $('#rejectmodal').addClass('show').css('display', 'block');
        $('body').addClass('modal-open').append('<div class="modal-backdrop modal2 fade show modal2"></div>');
    };
    const openModal3 = async (challanNo, centername, centercode) => {
        try {
            setCenterName(centername);
            setCenterCode(centercode);
            setLoading(true);
            const response = await axios.post(`${config.API_BASE_URL}/auth/GetStudentListByChallan`, {
                challaN_NO: challanNo
            }, {
                headers: { Authorization: `Bearer ${token2}` },
            });
            setModalData2(response.data.data.student_list);
            localStorage.setItem("modalOpen", "true");
            setShowModal(true); // Show modal
            $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
            $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
        } catch (error) {
            console.error("Error fetching modal data:", error);
        } finally {
            setLoading(false);
        }
    };
    const closeModal = () => {
        // Close the main modal
        $("#uploadModal").removeClass("show").css("display", "none");

        // Remove only the modal-backdrop with class `modal1`
        $(".modal-backdrop.modal1").remove();

        // Ensure body remains modal-open if another modal is still active
        if ($(".modal.show").length === 0) {
            $("body").removeClass("modal-open");
        }

        // Clear modal data
        setModalData({});
    };

    const closeModal2 = () => {
        // Close the reject modal
        $("#rejectmodal").removeClass("show").css("display", "none");

        // Remove only the modal-backdrop with class `modal2`
        $(".modal-backdrop.modal2").remove();

        // Ensure body remains modal-open if another modal is still active
        if ($(".modal.show").length === 0) {
            $("body").removeClass("modal-open");
        }
    };
    const closeModal3 = () => {
        setModalData([]); // Reset the modal data
        setShowModal(false); // Hide the modal
        localStorage.removeItem("modalOpen"); // Optionally
        $("body").removeClass("modal-open");
        $(".modal-backdrop").remove();
    };
    // const downloadImage = () => {
    //     if (!chFile) {
    //         alert("No image available to download.");
    //         return;
    //     }

    //     // Create a download link
    //     const link = document.createElement("a");
    //     link.href = chFile; // Direct image URL

    //     // Force the filename to end with .jpg
    //     link.download = "downloaded-image.jpg";

    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };
    // function downloadImage() {
    //     if (!chFile) {
    //         alert("No image available to download.");
    //         return;
    //     }

    //     debugger;
    //     // Ensure the URL uses HTTPS
    //     var url = chFile.replace(/^http:/, "https:");


    //     // Extract the filename and extension
    //     let urlParts = url.split("/");
    //     let originalFilename = urlParts[urlParts.length - 1];
    //     let newFilename = "chfile" + originalFilename.substring(originalFilename.lastIndexOf("."));

    //     // Fetch the file as a blob
    //     fetch(url)
    //         .then(response => response.blob())
    //         .then(blob => {
    //             const blobUrl = URL.createObjectURL(blob);
    //             const link = document.createElement("a");
    //             link.href = blobUrl;
    //             link.download = newFilename;

    //             // Append, trigger download, and clean up
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);
    //             URL.revokeObjectURL(blobUrl);
    //         })
    //         .catch(error => console.error("Download failed:", error));
    // }

    function downloadImage() {
        if (!chFile) {
            alert("No image available to download.");
            return;
        }

        // Ensure HTTPS for mixed content issues
        var url = chFile.replace(/^http:/, "https:");

        // Extract filename and extension
        let urlParts = url.split("/");
        let originalFilename = urlParts[urlParts.length - 1];
        let newFilename = "chfile" + originalFilename.substring(originalFilename.lastIndexOf("."));

        // Use fetch with CORS proxy if needed
        const proxyUrl = "https://cors-anywhere.herokuapp.com/";
        const urlWithProxy = proxyUrl + url;

        fetch(urlWithProxy)
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.blob();
            })
            .then(blob => {
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = newFilename;

                // Append, trigger download, and clean up
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
            })
            .catch(error => console.error("Download failed:", error));
    }


    const generateExcel = async () => {
        if (!modalData2.length) {
            Swal.fire("No Data", "No student data available for export.", "warning");
            return;
        }

        const token2 = localStorage.getItem("token2");
        if (!token2) {
            Swal.fire("Authentication Error", "Token is missing. Please log in.", "error");
            return;
        }

        try {
            setLoading(true);
            const now = new Date();
            const formattedDateTime = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()} ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;

            // Calculate total exam fees
            const totalFees = modalData2.reduce((total, student) => total + (parseFloat(student.FEES_AMOUNT) || 0), 0);

            const ws = XLSX.utils.aoa_to_sheet([
                ["Annexure"],
                ["Centre Code:", centerCode],
                ["Centre Name:", centerName],
                ["Challan No:", modalData2[0]?.CHALLAN_NO],
                ["Generation Date & Time:", formattedDateTime],
                [],
                [],
                ["Roll No", "Student Name", "Gender", "Father Name", "Mother Name", "Caste", "Exam Type", "Exam Fees"]
            ]);

            const rows = modalData2.map(student => [
                student.ROLL_NO || "",
                student.CAND_NAME || "",
                student.SEX || "",
                student.FATHERS_NAME || "",
                student.MOTHERS_NAME || "",
                student.CATEGORY || "",
                student.EXAM_TYPE || "",
                student.FEES_AMOUNT || "",
            ]);

            // Add student rows
            XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

            // Add total fees row
            XLSX.utils.sheet_add_aoa(ws, [["", "", "", "", "", "", "Total Fees:", totalFees]], { origin: -1 });

            // Merge title cell
            ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];

            // Adjust column widths
            ws["!cols"] = [
                { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 20 }, { wch: 15 },
                { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 30 }
            ];

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Checklist");

            const fileName = `Annexure_${modalData2[0]?.CHALLAN_NO}.xlsx`;
            XLSX.writeFile(wb, fileName);

            setLoading(false);

            Swal.fire({
                title: "Success",
                text: "Excel file has been generated successfully!",
                icon: "success",
                timer: 1500,
                showConfirmButton: false
            });

        } catch (error) {
            console.error("Error generating Excel:", error);
            setLoading(false);
            Swal.fire("Error", "An error occurred while generating the checklist.", "error");
        }
    };


    const handleSubmit = async (status) => {
        let remarks = "";

        if (status === "REJECTED") {
            remarks = remarksRef.current ? remarksRef.current.value.trim() : "";

            if (!remarks) {
                Swal.fire({
                    icon: "warning",
                    title: "Remarks Required",
                    text: "Please provide remarks before rejecting.",
                    customClass: "custom-swal",
                });
                return;
            }
        }

        setLoading(true); // Start loader
        console.log(remarks);
        console.log(challanNo);
        console.log(status);

        try {
            const response = await axios.post(
                `${config.API_BASE_URL}/auth/UpdateAdminStatus`,
                JSON.stringify({
                    remarks: remarks, // Blank if "APPROVED", user input if "REJECTED"
                    cH_NO: challanNo,
                    stat: status,
                }),
                {
                    headers: {
                        Authorization: `Bearer ${token2}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("API Response:", response.data);

            setLoading(false); // Stop loader

            // Show success alert and reload after confirmation
            Swal.fire({
                icon: "success",
                title: "Success",
                text: `Request ${status} successfully!`,
                customClass: "custom-swal",
            }).then(() => {
                window.location.reload(); // Reload the page after user closes the alert
            });

            // Close modals
            if (status === "APPROVED") {
                closeModal();
            } else {
                closeModal();
                closeModal2();
            }

        } catch (error) {
            setLoading(false); // Stop loader on error
            console.error("Error submitting:", error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong. Please try again.",
                customClass: "custom-swal",
            });
        }
    };


    return (
        <div className="pc-container">
            {loading && (
                <div className="custom-loader-container">
                    <div className="custom-loader"></div>
                </div>
            )}
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12 breadcrumb">
                                <div className="page-header-title">
                                    <h5 className="m-b-10">PAYMENTS PENDING FOR VERIFICATION</h5>
                                </div>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="" onClick={movetodashboard}>
                                            Home
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="">PAYMENTS PENDING FOR VERIFICATION</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ padding: "0px" }}>
                    <div className="col-md-12">
                        <div className="card tbl-card" style={{ border: "1px solid #1890ff" }}>
                            <div className="card-body padding-10">
                                <div className="table-responsive">
                                    <table ref={tableRef} className="table table-hover table-bordered mb-0">
                                        <thead>
                                            <tr className="table-info">
                                                <th>Sl. No</th>
                                                <th>Centre Code</th>
                                                <th>Centre Name</th>
                                                <th>Challan Number</th>
                                                <th className="text-start">Number of Students</th>
                                                <th className="text-start">Print Annexure</th>
                                                <th>Challan Generation Date & Time</th>
                                                <th>Payment Upload Date & Time</th>
                                                <th className="text-start">Initiate Verification</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.length > 0 ? (
                                                data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.CENTER_CODE}</td>
                                                        <td>{item.CENTER_NAME}</td>
                                                        <td>{item.CHALLAN_NO}</td>
                                                        <td>{item.NO_OF_STUDENT}</td>
                                                        <td> <td><button className="btn btn-sm btn-info" onClick={() => openModal3(item.CHALLAN_NO, item.CENTER_NAME, item.CENTER_CODE)}><i className="fa fa-print"></i>&nbsp;Print Annexure</button></td></td>
                                                        <td><span className="badge bg-light-warning border border-warning" style={{ fontSize: '10px' }}>{item.CHALLAN_DATE_TIME}</span></td>
                                                        <td><span className="badge bg-light-success border border-success" style={{ fontSize: '10px' }}>{item.PAYMEN_DATE_TIME}</span></td>

                                                        <td className="text-start">
                                                            <button
                                                                className="btn btn-info btn-sm"
                                                                onClick={() => openModal(item.CHALLAN_NO)}
                                                            >
                                                                Initiate Verification
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="uploadModal" tabIndex="-1" role="dialog" ref={modalRef}>
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-info">
                                <h5 className="modal-title">Uploaded Payment Details ( Challan No : {challanNo} )</h5>
                                <button type="button" className="btn-close" onClick={closeModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-7">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '40%' }}>Payment Mode :</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            name="utrNumber"
                                                            className="form-control form-control-sm"
                                                            value={modalData.PAYMENT_MODE || ""}
                                                            disabled
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Transaction Date :</td>
                                                    <td>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="paymentDate"
                                                            disabled
                                                            value={modalData.PAYMENT_DATE || ""}
                                                        />

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Transaction Number :</td>
                                                    <td>

                                                        <input
                                                            type="text"
                                                            name="document"
                                                            className="form-control form-control-sm"
                                                            disabled
                                                            value={modalData.TRANSACTION_NUMBER || ""}
                                                        />

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Bank Name :</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            name="bankName"
                                                            className="form-control form-control-sm"
                                                            value={modalData.BANK_NAME || ""}
                                                            disabled
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Amount :</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            name="amount"
                                                            className="form-control form-control-sm text-right"
                                                            disabled
                                                            value={modalData.EXAM_FEES || ""}
                                                        />
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-md-5" style={{ textAlign: 'center' }}>
                                        {/* <div style={{ height: '230px', width: '100%', marginBottom: '10px' }}>
                                            <img style={{ height: '100%', width: '100%' }} src={chFile || ""}
                                                alt="Image Preview" />
                                        </div> */}
                                        <div style={{
                                            height: '230px',
                                            width: '100%',
                                            marginBottom: '10px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            fontSize: '18px' // Adjust as needed
                                        }}>
                                            {isImage ? (
                                                <a href={chFile} target="_blank" rel="noopener noreferrer"
                                                    style={{
                                                        textDecoration: 'none',
                                                        color: 'black',
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold',
                                                        padding: '10px 15px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '5px',
                                                        backgroundColor: '#f8f9fa',
                                                        transition: 'background 0.3s'
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#e2e6ea'}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                >
                                                    🖼️ View Details
                                                </a>
                                            ) : isPDF ? (
                                                <a href={chFile} target="_blank" rel="noopener noreferrer"
                                                    style={{
                                                        textDecoration: 'none',
                                                        color: 'black',
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold',
                                                        padding: '10px 15px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '5px',
                                                        backgroundColor: '#f8f9fa',
                                                        transition: 'background 0.3s'
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#e2e6ea'}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                >
                                                    📄 View Details
                                                </a>
                                            ) : (
                                                <p>Unsupported file format</p>
                                            )}
                                        </div>
                                        {/* <button className="btn btn-info btn-sm" onClick={downloadImage}><i className="fa fa-download"></i>&nbsp;Download</button> */}
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => openModal2()}>
                                    <i className="fa fa-times"></i>&nbsp;Reject
                                </button>
                                <button type="button" className="btn btn-primary btn-sm" onClick={() => handleSubmit("APPROVED")}>
                                    <i className="fa fa-save"></i>&nbsp;Approve
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="rejectmodal" tabIndex="-1" role="dialog" ref={modalRef2} style={{ zIndex: '2000' }}>
                    <div className="modal-dialog modal-md" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-info">
                                <h5 className="modal-title">Reject Payment Details</h5>
                                <button type="button" className="btn-close" onClick={closeModal2}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>Remarks :</h5>
                                        <textarea className="form-control" rows={4} ref={remarksRef}></textarea>
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary btn-sm" onClick={closeModal2}>
                                    <i className="fa fa-times"></i>&nbsp;Cancel
                                </button>
                                <button type="button" className="btn btn-primary btn-sm" onClick={() => handleSubmit("REJECTED")}>
                                    <i className="fa fa-save"></i>&nbsp;Save
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
                {showModal && (
                    <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }}>
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header bg-info">
                                    <h5 className="modal-title">Challan No : {modalData2[0]?.CHALLAN_NO}<br />Generation Date & Time : {modalData2[0]?.CHALLAN_DATE_TIME}</h5>
                                    <button type="button" className="btn-close" onClick={closeModal3}></button>
                                </div>
                                <div className="modal-body">
                                    {modalData2.length > 0 && (
                                        <div className="col-md-3" style={{ position: 'absolute', top: '35px', zIndex: '1', left: '20px' }}>
                                            <button
                                                className="btn btn-sm btn-danger"
                                                onClick={generateExcel}
                                            >
                                                <RiFileExcel2Fill style={{ marginTop: "-4px" }} />&nbsp;Export to Excel
                                            </button>
                                        </div>
                                    )}
                                    <table ref={tableRef2} class="table table-hover table-bordered mb-0">
                                        <thead>
                                            <tr className='table-info'>
                                                <th className="text-start">Sl No.</th>
                                                <th>Roll No</th>
                                                <th>Name of Candidate</th>
                                                <th className="text-start">Gender</th>
                                                <th className="text-start">Father's Name</th>
                                                <th className="text-start">Mother's Name</th>
                                                <th>Caste</th>
                                                <th>Exam Type</th>
                                                <th>Exam Fees</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {modalData2.map((student, index) => (
                                                <tr key={index}>
                                                    <td className="text-start">{index + 1}</td>
                                                    <td>{student.ROLL_NO}</td>
                                                    <td>{student.CAND_NAME}</td>
                                                    <td>{student.SEX}</td>
                                                    <td className="text-start">{student.FATHERS_NAME}</td>
                                                    <td className="text-start">{student.MOTHERS_NAME}</td>
                                                    <td className="text-start">{student.CATEGORY}</td>
                                                    <td>{student.EXAM_TYPE}</td>
                                                    <td>{student.FEES_AMOUNT}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="table-warning">
                                                <td colSpan="8" className="text-end fw-bold">Total Fees:</td>
                                                <td className="fw-bold">
                                                    {modalData2.reduce((total, student) => total + (parseFloat(student.FEES_AMOUNT) || 0), 0)}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={closeModal3}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default BoardPending;
